module.exports = __webpack_public_path__ + "static/media/IMG_2958-min.b17d24c8.JPG";